import { MiniGameModel, MiniGameTypeEnum } from './MiniGameModel';

export enum TaskType {
    Regular = 'Regular',
    Global = 'Global'
}

export interface TaskModelOptions {
    type: TaskType;
    score: number;
    timeoutScoreForfeit: number;
    failScoreForfeit: number;
    time: number[];
    miniGameType: MiniGameTypeEnum;
    miniGameRoomLink: MiniGameModel;
    text: string;
    active: boolean;
    index: number;
}

export class TaskModel {
    public type: TaskType;
    public score: number;
    public timeoutScoreForfeit: number = 0;
    public failScoreForfeit: number = 0;
    public time: number = 0;
    public timeList: number[] = null;
    public timeRunning: boolean;
    public active: boolean;
    public pause: boolean;
    public miniGameType: MiniGameTypeEnum;
    public miniGameLink: MiniGameModel;
    public text: string;

    public index: number = -1;

    constructor(options?: TaskModelOptions) {
        if (options) {
            this.type = options.type;
            this.score = options.score;
            this.timeList = options.time;
            this.timeRunning = true;
            this.miniGameType = options.miniGameType;
            this.miniGameLink = options.miniGameRoomLink;
            this.text = options.text;
            this.active = options.active;
            this.index = options.index;
            this.pause = false;

        } else {
            this.active = false;
            this.timeRunning = false;
            this.pause = false;
        }
    }
}
